import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { machineCheck } = Urls;

const path = name => `app/pages/machineCheck/${name}`;
let listOfTranker;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listClient: {
            data: [],
            handlers: {
                get(state, action) {
                    return action.payload;
                },
                add(state, action) {
                    return [...action.payload, ...state];
                },
                del(state, action) {
                    return state.filter(item => item._id !== action.payload);
                },
                update(state, action) {
                    return state.map(item => (item._id === action.payload._id ? action.payload : item));
                },
            },
        },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },

    pDieMobile:{
        data: 0,
        handlers: {
            changepDieMobile(state, action) {
                return action.payload;
            },
        },
    },
    batteryStatus:{
        data: 0,
        handlers: {
            changepBatteryStatus(state, action) {
                return action.payload;
            },
        },
    },
    blackScreen:{
        data: 0,
        handlers: {
            changepBlackScreen(state, action) {
                return action.payload;
            },
        },
    },
    valueInput: {
        data:{
            value :''
        },
        handlers: {
            setValueInput(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    transferDataCopy: {
        data: {
            selectedRowKeys1: [],
        },
        handlers: {
            getTransferDataCopy(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 20,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    listAllChild: {
        data: [],
        handlers: {
            getlistAllChild(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: true,
            isSendCommend: false,
            resultShowStatus: false,
            isOrderLoading:false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().machineCheck;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};


// 重启
export const addCheckData = params => {
    return async (dispatch, getState) => {
        try {
            await request(machineCheck.addMachine, 'POST', params);
            message.success('操作成功');
        } catch (e) {
            throw new Error(e);
        }
    };

};


export const addCommandDb = () => {
    return async (dispatch, getState) => {
        try {
            await request(machineCheck.addCommandDb, 'POST');
            message.success('操作成功');
        } catch (e) {
            throw new Error(e);
        }
    };
};





// WEBPACK FOOTER //
// ./pages/client/machineCheck/reducers.js